import { Button, Grid, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Typography } from "@mui/material";
import Sidebar from "./Sidebar";
import { useEffect, useState } from "react";
import axios from "axios";
import { Delete, Edit } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

export default function Services() {

    var url = `http://localhost:${process.env?.PORT || 3000}/`

    var navi = useNavigate();

    function CheckLogIn() {

        var id = localStorage.getItem('uuid');
        if (id == '') {
            navi('/')
        }

    }

    useEffect(() => {
        CheckLogIn();
    }, [])

    const [categories, setCategories] = useState([]);
    async function fetchCategories() {
        try {

            const response = await axios.post(url + 'admin/categories/fetch');

            if (response.data.response === "success") {
                setCategories(response.data.data || []);
            } else {
                alert(response.data.reason);
            }
        } catch (error) {
            console.log("Fetch Categories Error!!!!:", error);
        }
    };

    useEffect(() => {
        fetchCategories();
    }, []);



    var uid = localStorage.getItem('uuid');

    function addService(e) {
        e.preventDefault();

        const data = new FormData(e.currentTarget);

        const category = JSON.parse(data.get('category'));

        axios.post(url + 'shop/services/add', {
            Id: uid,
            Service: data.get('name'),
            Duration: Number(data.get('duration')),
            Price: Number(data.get('price')),
            Category: category
        }).then((res) => {
            fetchServices();
            e.target.reset();
        });
    }


    const columns = [
        { id: 'name', Label: 'Name', },
        { id: 'action', Label: 'Price', },
        { id: 'action', Label: 'Duration', },
        { id: 'action', Label: 'Category', },
        { id: 'action', Label: 'Action', },
    ];

    const [services, setservices] = useState([]);
    function fetchServices() {
        var uid = localStorage.getItem('uuid');
        axios.post(url + 'getShop', {
            Id: uid
        }).then((succ) => {
            setservices(succ.data.Services);
            console.log(succ.data.Services);
        })
    }
    useEffect(() => {
        fetchServices();
    }, [])

    function deleteService(value) {
        // var
        axios.post(url + 'deleteService', {
            Id: uid,
            Value: value,
        }).then((succ) => {
            fetchServices();
        })
    }

    const [duration, setduration] = useState([5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100, 105, 110, 115, 120, 135, 150, 165, 180, 210, 240, 270, 300, 330, 360, 390, 420])

    function convertTime(time) {
        var hours = Math.floor(time / 60);
        var mins = time % 60;
        return `${hours} hr ${mins} mins`
    }

    // const check = 23;

    return (
        <>

            <Grid container height={'100vh'} className='admin-Section' width={'100%'}>
                <Sidebar />
                <Grid height={'100%'} flexGrow={1} p={3}>
                    <Grid alignItems={'flex-start'} container width={'100%'} justifyContent={'space-between'}>
                        {/* <Grid className='admin-section '> */}
                        <Grid size={{ lg: 4.5 }} p={2} className='bg-blue rounded text-white addService shadow'>
                            <Typography variant="h4">Add Service</Typography>
                            {/* <TextField /> */}
                            {/* <input type="text" className="form-control mt-3" placeholder="Give Suitable Title for the image" /> */}
                            <form onSubmit={addService}>
                                <input required type="text" name="name" className="form-control mt-2" placeholder='Name' fullWidth />
                                <div className="row m-0 mt-2 justify-content-between">
                                    <Grid size={{ lg: 5.7 }} className="px-0">
                                        <input required type="number" name="price" className="form-control" placeholder='Price(e.g. ₹0.00)' fullWidth />
                                    </Grid>
                                    <Grid size={{ lg: 5.7 }} className="px-0">
                                        {/* <input  name="name" className="form-control" placeholder='Name' fullWidth /> */}
                                        <select name="duration" className="select">
                                            {duration.map((row) => (
                                                <option req value={row}>{convertTime(row)}</option>
                                            ))}
                                        </select>
                                    </Grid>
                                    <div className="col-lg-12 px-0">
                                        {/* <input  name="name" className="form-control" placeholder='Name' fullWidth /> */}
                                        <select name="category" required className="select mt-2">
                                            {Array.isArray(categories) && categories.map((row) => (
                                                <option
                                                    key={row._id}
                                                    value={JSON.stringify({
                                                        id: row._id,
                                                        name: row.Slug
                                                    })}
                                                >
                                                    {row.Name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <button type="submit" className="mt-2 btn btn-outline-white text-white w-100" variant="outlined" fullWidth>
                                    <Typography textTransform={'capitalize'} variant="body1">Submit</Typography>
                                </button>
                            </form>

                        </Grid>
                        <Grid className='bg-transparent' size={{ lg: 7 }}>
                            <TableContainer sx={{ background: '#0F1536', color: 'white', borderRadius: 3 }}>
                                <Table aria-label="listed services table" className="">
                                    {/* <caption>A basic table example with a caption</caption> */}
                                    <TableHead>
                                        <TableRow>
                                            {columns.map((column) => (
                                                <TableCell
                                                className="text-white"
                                                    key={column.id}
                                                    align={column.Label == 'Actions' ? 'center' : 'left'}
                                                    style={{ minWidth: column.minWidth }}
                                                >
                                                    {column.Label}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {services?.length > 0 ? (

                                            services.map((row) => (
                                                <TableRow key={row} className="mt-0 text-white">
                                                    <TableCell className="text-white">{row.Name}</TableCell>
                                                    <TableCell className="text-white">₹{row.Price}</TableCell>
                                                    <TableCell className="text-white">{convertTime(row.Duration)}</TableCell>
                                                    <TableCell className="text-white">{row?.CategoryName}</TableCell>
                                                    <TableCell className="text-white" align="center">
                                                        <IconButton onClick={() => deleteService(row)} size="small">
                                                            <Delete sx={{color:"white"}} />
                                                        </IconButton>
                                                    </TableCell>
                                                </TableRow>
                                            ))
                                        ) : (
                                            <>
                                                <br />
                                                <Typography variant="'h6">You haven't added any service</Typography>

                                            </>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                        {/* </Grid> */}
                    </Grid>
                </Grid>
            </Grid >

        </>
    )

}